export const getRoundedDiscountedProductPrice = (
  price: number,
  discount = 0,
  discountAmount = 0
) => {
  if (discount) {
    return Math.floor(price * (1 - discount / 100));
  }
  if (discountAmount) {
    return Math.floor(price - discountAmount);
  }
  return Math.floor(price);
};
